import { createContext, useCallback, useEffect, useState } from 'react';
import uniqueBy from 'unique-by';
import { debounce, openWindow } from '../utils/utils';
import { gameSet } from '../utils/data';

export const GamesContext = createContext();

export const GamesProvider = ({ api, children }) => {
  const [gameSets, setGameSets] = useState([]);

  useEffect(() => {
    api.get('/games/sets').then(res => {
      setGameSets(res.data.data)
    })
  }, [])

  function findGameById(gameId) {
    return gameSet(gameSets, "All Games")
      .find(game => game.id === gameId)
  }


  const [search, setSearch] = useState('');
  const [searchResults, setsearchResults] = useState([]);

  useEffect(() => {
    if (search.length) {
      debounceSearch(search);
    }
  }, [search]);

  const debounceSearch = useCallback(
    debounce(keyword => searchGames(keyword)),
    []
  );

  const searchGames = (keyword) => {
    api.get('/games/search', {params: {key: keyword}}).then(res => {
      if (res.data.data) {
        setsearchResults(res.data.data)
      }
    })
  };


  async function openGame(game) {
    const gameUrl = api.buildUrl('/launch', { gameId: game.id, key: api.token });
    openWindow({ url: gameUrl, height: 600, width: 800 });
    appendToLastPlayed(game);
  };

  function appendToLastPlayed(game) {
    const updated = gameSets.map(gameSet => 
      gameSet.name === "Last Played"
      ? { ...gameSet, games: uniqueBy([ game, ...gameSet.games ], "id") }
      : gameSet
    )
    setGameSets(updated)
  }


  const value = {
    findGameById,
    allGames: gameSet(gameSets, "All Games"),
    gameSets,
    search,
    setSearch,
    searchResults,
    openGame
  };

  return (
    <GamesContext.Provider value={value}>{children}</GamesContext.Provider>
  );
};
